import React, { useContext, useEffect, useState } from "react";
import {
	HiOutlineBookOpen,
	HiOutlineCodeBracket,
	HiOutlineComputerDesktop,
	HiOutlinePencilSquare,
} from "react-icons/hi2";
import { AuthContext } from "../context/AuthContext";
import { getApi } from "../services/api";
import DetailCourseCard from "../components/common/cards/DetailCourseCard";
import { toast } from "react-toastify";

const Enroll = () => {
	const [activeCategory, setActiveCategory] = useState("");
	const [categories, setCategories] = useState([]);
	const [courses, setCourses] = useState([]);
	const { login } = useContext(AuthContext);

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				const response = await getApi(`/courseCategory`);
				if (response && !response.error) {
					setCategories(response); // Set fetched categories
					// Set the first category as the active category if there are categories
					if (response.length > 0) {
						setActiveCategory(response[0].title);
					}
				} else {
					console.error(
						"Error fetching categories:",
						response.message || "Unknown error"
					);
					toast.error(
						response.message || "Failed to fetch categories."
					);
				}
			} catch (error) {
				console.error("Error fetching categories:", error.message);
				toast.error("Error fetching categories. Please try again.");
			}
		};

		fetchCategories();
	}, [login]);

	// Fetch courses based on the active category
	useEffect(() => {
		const fetchCourses = async () => {
			try {
				const response = await getApi(
					`/courses?filter[category]=${activeCategory}`
				);
				if (response && !response.error) {
					setCourses(response); // Set fetched courses
				} else {
					console.error(
						"Error fetching courses:",
						response.message || "Unknown error"
					);
				}
			} catch (error) {
				console.error("Error fetching courses:", error.message);
			}
		};

		if (activeCategory) {
			fetchCourses();
		}
	}, [activeCategory]);

	// Map category names to Hero Icons
	const categoryIcons = {
		"Data Science": (
			<HiOutlineBookOpen className="inline-block text-xl mr-2" />
		),
		"IT Certifications": (
			<HiOutlineComputerDesktop className="inline-block text-xl mr-2" />
		),
		Programming: (
			<HiOutlineCodeBracket className="inline-block text-xl mr-2" />
		),
		"Graphic Design": (
			<HiOutlinePencilSquare className="inline-block text-xl mr-2" />
		),
	};

	return (
		<div className="min-h-screen p-8 text-black mt-20 bg-white m-3">
			{/* Tab Navigation */}
			<div className="flex gap-3 mb-8 justify-center">
				{categories.map((category) => (
					<button
						key={category._id}
						className={`px-6 py-2 rounded-full text-sm font-semibold ${
							activeCategory === category.title
								? "bg-blue-600 text-white border border-blue-700"
								: "bg-gray-200 text-gray-800 hover:bg-blue-600 hover:text-white hover:border-blue-700"
						}`}
						onClick={() => {
							setActiveCategory(category.title);
						}}
					>
						{categoryIcons[category.title]} {category.title}
					</button>
				))}
			</div>

			{/* Course Cards */}
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
				{courses.length > 0 ? (
					courses.map((course) => (
						<DetailCourseCard key={course._id} course={course} />
					))
				) : (
					<div className="col-span-1 sm:col-span-2 md:col-span-4 text-center">
						<p className="text-gray-500">
							No courses available for this category.
						</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default Enroll;
